import Flickity from 'flickity'
import on from 'dom-event'
import debounce from 'lodash/debounce'

export default el => {
  const selectors = {
    slider: '.plp-shopby__list',
    slide: '.plp-shopby__list--item'
  }

  const slides = [...el.querySelectorAll(selectors.slide)]
  const sliderEl = el.querySelector(selectors.slider)

  let flickityInstance = null

  function initSlider () {
    if (!flickityInstance) {
      flickityInstance = new Flickity(sliderEl, {
        prevNextButtons: true,
        pageDots: false,
        cellAlign: 'left',
        freeScroll: false,
        wrapAround: false,
        groupCells: true,
        contain: true
      })
    }
  }

  function destroySlider () {
    if (flickityInstance) {
      flickityInstance.destroy()
      flickityInstance = null
    }
  }

  function checkSliderActive () {
    const windowWidth = window.innerWidth

    if ((windowWidth <= 1129 && slides.length > 1) || (windowWidth >= 1130 && slides.length > 8)) {
      initSlider()
    } else {
      destroySlider()
    }
  }

  checkSliderActive()
  on(window, 'resize', debounce(checkSliderActive, 300))
}
